import {Avatar, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import szamlazzLogo from "../../../assets/szamlazz.jpg"
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import {useContext} from "react";
import DisabledWrapper from "../../../components/DisabledWrapper";
import {AuthContext} from "../../../context/AuthContext";
import {hasPermission} from "../../../utils/permissionUtils";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SubscriptionContext from "../../../context/SubscriptionContext";


const SzamlazzDisplay = ({credential, onMakeActive, onDeactivate, onEdit, onDelete}) => {
    const {name, active} = credential;
    const {getUser} = useContext(AuthContext)
    const {hasPlan} = useContext(SubscriptionContext);
    const user = getUser()

    const disabledCause = [{
        disabled: !hasPlan('billing', 'update'),
        message: 'A jelenlegi csomagod nem tartalmazza ezt a funkciót. Válassz egy nagyobb csomagot a használathoz!'
    }, {
        disabled: !hasPermission(user, 'billing', 'update'),
        message: 'Nincs jogosultságod ehhez a művelethez!'
    }]
    const disabledCauseDelete = [{
        disabled: !hasPlan('billing', 'delete'),
        message: 'A jelenlegi csomagod nem tartalmazza ezt a funkciót. Válassz egy nagyobb csomagot a használathoz!'
    }, {
        disabled: !hasPermission(user, 'billing', 'delete'),
        message: 'Nincs jogosultságod ehhez a művelethez!'
    }]

    return <Stack direction='row' justifyContent='space-between' sx={{width: '100%'}}>
        <Stack direction='row' spacing={2} alignItems='center'>
            <Avatar src={szamlazzLogo} sx={{width: 70, height: 70, alignSelf: 'center'}}/>
            <div className="text-container">
                <Stack direction='row' spacing={1} justifyContent='center' alignItems='center'>
                    <Typography align="left" variant="subtitle1">{name}</Typography>
                    {active && <Tooltip title="Jelenleg aktív">
                        <div className='active-dot'/>
                    </Tooltip>}
                </Stack>
                <Typography align="left" variant="body2">Számlázz.hu</Typography>
            </div>
        </Stack>
        <Stack direction='row' spacing={2} alignItems='center'>
            <DisabledWrapper disabledCause={disabledCause}>
                <IconButton variant='dino' onClick={() => onEdit(credential.id)} title="Szerkesztés">
                    <EditIcon/>
                </IconButton>
            </DisabledWrapper>
            <DisabledWrapper disabledCause={disabledCauseDelete}>
                <IconButton variant='dino' onClick={() => onDelete(credential.id)} title="Törlés">
                    <DeleteIcon/>
                </IconButton>
            </DisabledWrapper>


            <DisabledWrapper disabledCause={disabledCause}>
                {!active ?
                    <IconButton variant='dino' onClick={() => onMakeActive(credential.id)} title="Aktiválás">
                        <CheckCircleIcon/>
                    </IconButton>
                    :
                    <IconButton variant='dino' onClick={() => onDeactivate(credential.id)} title="Deaktiválás">
                        <CancelRoundedIcon/>
                    </IconButton>
                }
            </DisabledWrapper>

        </Stack>
    </Stack>
}

export default SzamlazzDisplay